(function () {
    const inputTypeSearchElements = document.querySelectorAll("input[type='search']");
    if (inputTypeSearchElements.length > 0) {
        for (let i = 0, len = inputTypeSearchElements.length; i < len; i++) {
            inputTypeSearchElements[i].addEventListener("keydown", (e) => {
                const searchTerm = e.target.value;
                if (e.keyCode === 13 && searchTerm.length > 0 && typeof DY != "undefined" && typeof DY.API != "undefined") {
                    DY.API("event", {
                        name: "Keyword Search",
                        properties: {
                            dyType: "keyword-search-v1",
                            keywords: searchTerm,
                        },
                    });
                }
            });
        }
    }
})();
